import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import QuickLinksGrid from './QuickLinksGrid';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import { selectors as dashboardMaintenanceSelectors } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';

const params = new URLSearchParams(location.search);

const mapStateToProps = (state: IApplicationState) => ({
    selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QuickLinksGrid);
